  <lib-alert 
    [show]="true"
    [showIcon]="true"
    [centerContent]="true"
    [dismissible]="false"
    type="warning">
    <p class="question">Need help with your contract?</p>
    <p class="cta"><a [routerLink]="['/user-profile/my-contracts']">Schedule a call</a> with one of our lawyers today!</p>
  </lib-alert>

